import { formatAccessibleDate } from '@/core/utils/date/formatAccessibleDate'
import { getFormattedDates } from '@/core/utils/dom/getFormattedDate'

import { VisuallyHidden } from '../VisuallyHidden'

interface DateTimeProps {
  date?: string | number
  accessibleLabel?: string
}

export default function DateTime({ date, accessibleLabel }: DateTimeProps) {
  if (!date) return null

  const dateISOFormat = new Date(date).toISOString()
  const formattedDate = getFormattedDates(date)?.visually
  const accessibleDate = accessibleLabel || formatAccessibleDate(formattedDate)

  return (
    <>
      <VisuallyHidden>{accessibleDate}</VisuallyHidden>
      <time dateTime={dateISOFormat} aria-hidden>
        {formattedDate}
      </time>
    </>
  )
}
